import { StackLayerProps } from "../../types/DepartmentTypes";

export const StackLayer = ({
  position,
  opacity = 10,
  zIndex = 1,
}: StackLayerProps) => {
  let zIndexClass = "z-[1]";
  if (zIndex === 2) {
    zIndexClass = "z-[2]";
  } else if (zIndex !== 1) {
    zIndexClass = `z-[${zIndex}]`;
  }

  return (
    <div
      data-testid="stack-layer"
      className={`absolute ${position} right-0 left-0 bg-white/${opacity} dark:bg-white/${opacity === 10 ? 10 : 20} h-full rounded-3xl shadow-lg transition-all duration-700 ease-in-out ${zIndexClass}`}
    />
  );
};
